import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { URL } from '../../constants/urlMaps';
import { useUserAgentContext } from '../userAgent/context';
import Cookie from 'js-cookie';
import { HIDE_MOBILE_APP } from 'constants/cookie';
import { TLocationState } from '../../configureHistory';
import { useFlag } from 'utils/unleashFlags';
import { NEW_LANDING } from 'utils/unleashFlags/constants';

const useMobileLandingRedirect = () => {
  const history = useHistory<TLocationState>();
  const { isMobile } = useUserAgentContext();
  const landingFlag = useFlag(NEW_LANDING);
  useEffect(() => {
    /**
     * если юзер зашел с мобилы и кука hide-mobile-app-page не true, то редиректим
     * на страницу с баннером приложения. в стейте передаем страницу с которой редиректим
     * продолжение в src/Components/Link/LinkWithMobileCheck.tsx
     */
    if (isMobile && landingFlag?.variant === 'old') {
      history.listen(location => {
        const isMobilePageVisited = Cookie.get(HIDE_MOBILE_APP) === 'true';
        if (!isMobilePageVisited && location.state?.check) {
          history.replace({ pathname: URL.mobile_app, state: { prev: location } });
        }
      });
    }
  }, [history, isMobile, landingFlag]);
};

export default useMobileLandingRedirect;
